export default __webpack_public_path__ + "static/media/7.7982ddc3.png";